import React from "react"
import { Button as MuiButton } from "@material-ui/core"
import colours from "../themes/colours"

type Props = {
  label: string
  type?: "button" | "reset" | "submit"
  disabled?: boolean
  onClick?
  style?
}

const ContainedButton = ({ label, disabled, style, ...rest }: Props) => {
  const color = disabled ? colours.deemphasisedText : colours.white
  return (
    <MuiButton
      {...rest}
      variant="contained"
      color="primary"
      style={{
        borderColor: `${color}`,
        color,
        ...style
      }}
      disabled={disabled}
    >
      {label}
    </MuiButton>
  )
}

ContainedButton.defaultProps = {
  type: "button",
  disabled: false
}

export default ContainedButton
